import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#303030",
      d: "M6.25 11.25a.75.75 0 0 0 0 1.5H9a.75.75 0 0 0 0-1.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#303030",
      "fill-rule": "evenodd",
      d: "M2.5 7.25A2.75 2.75 0 0 1 5.25 4.5h9.5a2.75 2.75 0 0 1 2.75 2.75v5.5a2.75 2.75 0 0 1-2.75 2.75h-9.5a2.75 2.75 0 0 1-2.75-2.75zM14.75 6c.69 0 1.25.56 1.25 1.25H4C4 6.56 4.56 6 5.25 6zM16 9.25H4v3.5c0 .69.56 1.25 1.25 1.25h9.5c.69 0 1.25-.56 1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }